import { sanitizeSVG } from './svgSanitize'

/* eslint-disable import/prefer-default-export */
export async function sanitizeImage(file: File) {
  if (file.type === 'image/svg+xml') {
    const svgString = await file.text()
    const sanitizedSVG = sanitizeSVG(svgString)
    const sanitizedSVGFile = new File([sanitizedSVG], file.name, {
      type: file.type,
    })
    return sanitizedSVGFile
  }
  return file
}
